import CustomAdminSideBar from "@/components/adminSideBar";
import { AdminUserBar } from "@uigovpe/components";
import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

const APP_BASE_PATH = "/app/empreende-mulher";

const pageLabels: Record<string, string> = {
  "/": "Início",
  "/dashboard": "Início",
  "/profile": "Meu Perfil",
  "/feedback": "Feedback do Cadastro",
  "/my-products": "Meus Produtos",
  "/add-products": "Adicionar Produto",
};

export default function Layout() {
  const { pathname } = useLocation();
  const outletContainerRef = useRef<HTMLElement>(null);
  const currentLabel = pathname.match(/^\/my-products\/\d+\/edit$/)
    ? "Editar Produto"
    : pageLabels[pathname] ?? "Página";
  const isRunningInPortal = Boolean(
    document.getElementById("root")?.closest(".xvia-content-area"),
  );

  useEffect(() => {
    const portalContent = document
      .getElementById("root")
      ?.closest(".xvia-content-area") as HTMLElement | null | undefined;

    portalContent?.classList.add("empreende-mulher-content-area");

    return () => {
      portalContent?.classList.remove("empreende-mulher-content-area");
    };
  }, []);

  useEffect(() => {
    outletContainerRef.current?.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return (
    <div
      className={`flex min-h-0 w-full overflow-hidden ${
        isRunningInPortal ? "h-full" : "h-screen"
      }`}
    >
      <CustomAdminSideBar />

      <div className="flex h-full min-w-0 flex-1 flex-col">
        <AdminUserBar
          user={{ name: "", profile: "" }}
          ui={{
            container: { className: "empreende-userbar-without-user" },
            breadcrumb: { className: "hide-separators" },
            buttonMenu: {
              className:
                "text-primary! [&_.admin-userbar-sidebar-icon]:text-primary!",
            },
          }}
        //   user={{ name: "Empreendedora", profile: "Usuária" }}
          breadcrumb={{
            items: [
              { label: "Dashboard", url: `${APP_BASE_PATH}/` },
              { label: currentLabel },
            ],
          }}
        />

        <main
          ref={outletContainerRef}
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden bg-white px-10 pt-10"
        >
          <div className="pb-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
